import React from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { map } from 'lodash';
import { SideNav, TargetLogo, Heading } from '@enterprise-ui/canvas-ui-react';
import featureFlag from '../../util/featureFlag.js';

// eslint-disable-next-line no-unused-vars
var AppSideNav = function AppSideNav(_ref) {
  var appName = _ref.appName,
    sideNavItems = _ref.sideNavItems,
    isVisible = _ref.isVisible,
    onRequestClose = _ref.onRequestClose;
  var location = useLocation();
  var createNavItem = function createNavItem(navItem) {
    var path = navItem.path,
      label = navItem.label,
      hideInEnvironment = navItem.hideInEnvironment;
    return featureFlag(hideInEnvironment, /*#__PURE__*/React.createElement(SideNav.NavigationItem, {
      as: NavLink,
      to: path,
      className: location.pathname === path ? 'isSelected' : '',
      onClick: onRequestClose
    }, label));
  };
  var createNavGroup = function createNavGroup(navGroup) {
    var label = navGroup.label,
      hideInEnvironment = navGroup.hideInEnvironment,
      items = navGroup.items;
    return featureFlag(hideInEnvironment, /*#__PURE__*/React.createElement(SideNav.NavigationGroup, null, /*#__PURE__*/React.createElement(SideNav.NavigationItem, null, label), /*#__PURE__*/React.createElement(SideNav.NavigationGroupContent, null, items.map(function (item) {
      return createNavItem(item);
    }))));
  };
  return /*#__PURE__*/React.createElement(SideNav, {
    "data-testid": "sideNav",
    suppressAutoOpen: true,
    isVisible: isVisible,
    onRequestClose: onRequestClose,
    hasOverlay: true
  }, /*#__PURE__*/React.createElement(SideNav.Header, {
    "data-testid": "sideNavLogoHeader",
    as: NavLink,
    to: "/",
    onClick: onRequestClose
  }, /*#__PURE__*/React.createElement(TargetLogo, {
    size: "expanded",
    className: "hc-mr-dense"
  }), /*#__PURE__*/React.createElement(Heading, {
    size: 1,
    className: "hc-fs-md"
  }, appName)), /*#__PURE__*/React.createElement(SideNav.Navigation, {
    "data-testid": "sideNavMainNavArea"
  }, map(sideNavItems, function (item) {
    return item.type === 'group' ? createNavGroup(item) : createNavItem(item);
  })));
};

export { AppSideNav as default };
